module.exports = {"420114001":"蔡甸街道","420114002":"奓山街道","420114003":"永安街道","420114004":"侏儒山街道","420114005":"大集街道","420114006":"张湾街道","420114070":"沌口街","420114071":"军山街道","420114072":"沌阳街道","420114100":"索河镇","420114101":"玉贤镇","420114200":"消泗乡","420114400":"桐湖","420114401":"洪北管委会","420114404":"武汉市蔡甸区后官湖生态宜居新城管理委员会","420114405":"蔡甸经济开发区凤凰山事处","420114406":"成功现代都市农业发展区管理委员会","420114407":"武汉蔡甸经济发开区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420114.json
// module id = 1558
// module chunks = 0